import styled from 'styled-components';
import { Alert } from 'antd';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	width: 100%;
`;

export const PlayerPlaceholder = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	aspect-ratio: 16 / 9;
	padding: 1.5rem;
	background: ${({ theme }) => theme.palette.secondary[50]};
	border-radius: 1rem;
`;

export const EvaluationPlaceholder = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 7.5rem;
	padding: 3rem;
	background: ${({ theme }) => theme.palette.secondary[50]};
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	color: ${({ theme }) => theme.palette.secondary[300]};
	font-size: 1rem;
	line-height: 1.5rem;
	text-align: center;
`;

export const FooterRow = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
`;

export const RevisionAlert = styled(Alert)`
	align-items: flex-start;
	gap: 0.75rem;
	padding: 1rem;
	background: ${({ theme }) => theme.palette.primary[100]};
	border: none;
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};

	.ant-alert-icon {
		width: 1.5rem;
		height: 1.5rem;
		margin-right: 0;
		color: ${({ theme }) => theme.palette.primary[600]};
	}

	.ant-alert-message {
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: 0.875rem;
		line-height: 1.375rem;
	}
`;

export const PatchPanel = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.75rem;
	width: 100%;
	aspect-ratio: 16 / 9;
	padding: 1.5rem;
	background: ${({ theme }) => theme.palette.secondary[50]};
	border-radius: 1rem;
	text-align: center;
`;

export const PatchTitle = styled.span`
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.5rem;
`;

export const PatchMessage = styled.span`
	color: ${({ theme }) => theme.palette.secondary[300]};
	font-size: 0.875rem;
	line-height: 1.375rem;
`;

export const PatchErrorIcon = styled.div`
	display: flex;
	color: ${({ theme }) => theme.palette.risk.very_high.default};
	font-size: 3rem;
`;
